export function dateFmt(date: Date) {
  if (!date) return '';
  const day = date.toLocaleString('default', {day: '2-digit'});
  const month = date.toLocaleString('default', {month: 'short'});
  const year = date.toLocaleString('default', {year: 'numeric'});

  return `${day} ${month} ${year}`;
}
